import { render } from "./rabbitGrooming.vue?vue&type=template&id=36929321"
import script from "./rabbitGrooming.vue?vue&type=script&lang=js"
export * from "./rabbitGrooming.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__